import React, { useEffect, useState } from 'react';
import * as z from 'zod';
import img from '@/assets/new-logo.png';
import { Button, Spinner } from '@/components/Elements';
import { Form } from '@/components/Form';
import { resendOtp } from '../api/resendOtp';
import { useNotificationStore } from '@/stores/notifications';
import { useAuth } from '@/lib/auth';
import { useNavigate } from 'react-router-dom';
import OtpInput, { InputProps } from 'react-otp-input';
import i18next from 'i18next';
import './layout.css';

const EmailVerifyForm = ({ email }: { email: string }) => {
  const [resending, setIsResending] = useState(false);
  const [canResendOtp, setResend] = useState(false);
  const [count, setCount] = useState(45);
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const { register: verifyEmailApi, isRegistering, refetchUser } = useAuth();
  useEffect(() => {
    const timer: any = count > 0 && setInterval(() => setCount(count - 1), 1000);
    if (count <= 0) {
      setResend(true);
    } else {
      setResend(false);
    }
    return () => clearInterval(timer);
  }, [count]);

  const sendOtpAgain = async () => {
    try {
      setIsResending(true);
      await resendOtp({ email });
      useNotificationStore.getState().addNotification({
        title: `${i18next.t('Success')}`,
        type: 'info',
        message: 'Otp has been sent to your email address again!',
      });
    } finally {
      setIsResending(false);
      setCount(45);
    }
  };

  const resendClicked = () => {
    if (canResendOtp) {
      sendOtpAgain();
    }
  };

  const handleSubmit = async (e: any) => {
    if (!code || code.length !== 4) {
      e.preventDefault(); // Prevent submission if OTP is not complete
      setError(true);
      return;
    }
    try {
      const payload = {
        otp: code,
        email,
      };
      const response = await verifyEmailApi(payload);
       navigate(`/user/user-profile`);
      // refetchUser();
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Email verified successfully',
      });
    } catch (err) {
      console.error('Verification failed:', err);
      // useNotificationStore.getState().addNotification({
      //   title: 'Error',
      //   type: 'error',
      //   message: 'Verification failed. Please try again.',
      // });
    }
  };

  // const renderCustomInput = (inputProps: InputProps, index: number) => (
  //   <input
  //     key={index}
  //     {...inputProps}
  //     type="text"
  //     maxLength={1}
  //     className="inputfield"
  //     style={{
  //       width: '2em',
  //       height: '2em',
  //       fontSize: '1.5em',
  //       margin: '0.5em',
  //       background: '#D3D3D3',
  //     }}
  //   />
  // );

  const renderCustomInput = (inputProps: any, index: number) => (
    <input
      key={index}
      {...inputProps}
      type="text"
      maxLength={1}
      className="inputfield"
      style={{
        width: '2em',
        height: '2em',
        fontSize: '1.5em',
        margin: '0.5em',
        background: '#D3D3D3',
      }}
      onClick={(e) => {
        // Ensure the input is focused when clicked
        (e.target as HTMLInputElement).focus();
      }}
      onFocus={(e) => {
        // Optionally you could add a focus style for better UX
        e.target.style.backgroundColor = '#D3D3D3'; // or any color you want
      }}
      onBlur={(e) => {
        // Optionally reset focus style when focus is lost
        e.target.style.backgroundColor = '#D3D3D3'; // reset background
      }}
      // Ensure only digits can be entered
      onInput={(e) => {
        const input = e.target as HTMLInputElement;
        const value = input.value;
        // Remove any non-digit characters
        if (!/^\d$/.test(value)) {
          input.value = value.replace(/\D/g, ''); // Replace non-digits
        }
      }}
    />
  );

  const handleOtpChange = (code: string) => {
    setCode(code);
    setError(false);
  };
  return (
    <div>
      {/* <img src={img} width="70" alt="alttext" /> */}
      <div className="sign-up-logo ">
        <img src={img} alt="logo" className="v-logo " />
      </div>
      {/* <h1 className="my-4">Verify Email Address</h1> */}
      <h2 className="mt-5 mb-3 text-black">
        Verify Your Account
        {/* <p>
          <b>{email} </b>
        </p>{' '} */}
      </h2>

      <p className="my-4 text-black">
        A fresh verification link has been sent to your email address. Please check your inbox (and
        spam/junk folder, if necessary) to complete the verification process.
      </p>

      <div>
        <div className="row digits">
          <OtpInput
            onChange={handleOtpChange}
            value={code}
            numInputs={4}
            renderSeparator={<span style={{ width: '8px' }}></span>}
            shouldAutoFocus={true}
            renderInput={renderCustomInput}
          />
        </div>
        {error && <p className="mt-3 text-danger">Please enter otp</p>}

        <div className="my-4 d-flex">
          <Button
            isLoading={isRegistering}
            className="w-50 me-3"
            tabIndex={0}
            onClick={(e) => handleSubmit(e)}
          >
            {i18next.t('Continue')}
          </Button>

          <Button onClick={() => navigate(-1)} variant="outline" className="w-45" tabIndex={0}>
            {i18next.t(`Cancel`)}
          </Button>
        </div>
        {resending && <Spinner />}
        {!canResendOtp && count > 0 && (
          <span className="d-block mb-4 text-center">
            Resend code in: {count} <i className="fa-regular fa-clock" />
          </span>
        )}
        <div className="d-flex my-4 justify-content-center">
          {canResendOtp && (
            <p className="text-center">
              Didn&apos;t get the code?
              <span
                tabIndex={-1}
                //onKeyDown={resendClicked}
                role="button"
                onClick={resendClicked}
                className="text-blue-500 ps-1 pl-1 cursor-pointer"
              >
                Send the code again
              </span>
            </p>
          )}
        </div>
        <div className="or-text text-center">
          <p className="fs-14 w-50 mx-auto">Or</p>
        </div>
        <div className="v-login-btn text-center">
          <button
            type="button"
            className="btn px-4 underline"
            style={{ color: '#ff385c' }}
            onClick={() => navigate(`/auth/login-user`)}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailVerifyForm;
